import React from 'react';
import { Radio, RadioItem } from './Radio.styles';
var RadioCmp = function (_a) {
    //const [active, setActive] = useState(0);
    var options = _a.options, mode = _a.mode, name = _a.name, onChange = _a.onChange, value = _a.value;
    var onClick = function (index) { return function () {
        //setActive(index);
        onChange(options.filter(function (o, i) { return i === index; })[0].value);
    }; };
    return (React.createElement(Radio, { mode: mode }, options.map(function (o, i) { return (React.createElement(RadioItem, { onClick: onClick(i), mode: mode, key: i + "_" + name + "_radio", active: o.value === value }, o.label)); })));
};
export default RadioCmp;
